export const  SearchStatus = [
    {
        id: 1,
        name: 'همه',
        access: [0, 1, 2, 3, 4, 5, 6, 7]
    },{
        id: 2,
        name: 'هماهنگ شده',
        access: [6]
    },{
        id: 3,
        name: 'تثبیت نشده',
        access: [0, 1, 2, 3, 7]
    },{
        id: 4,
        name: 'انجام شده',
        access: [4]
    },{
        id: 5,
        name: 'کنسل شده کامل',
        access: [5]
    },{
        id: 5,
        name: 'بررسی نشده',
        access: [0]
    },
]